import * as React from "react";
import NavigationBuilderContext from "./NavigationBuilderContext";
/**
 * Hook to handle focus actions for a route.
 * Focus action needs to be treated specially, coz when a nested route is focused,
 * the parent navigators also needs to be focused.
 */ export default function useOnRouteFocus(param) {
    var router = param.router, getState = param.getState, sourceRouteKey = param.key, setState = param.setState;
    var _React_useContext = React.useContext(NavigationBuilderContext), onRouteFocusParent = _React_useContext.onRouteFocus;
    return React.useCallback(function(key) {
        var state = getState();
        var result = router.getStateForRouteFocus(state, key);
        if (result !== state) {
            setState(result);
        }
        if (onRouteFocusParent !== undefined && sourceRouteKey !== undefined) {
            onRouteFocusParent(sourceRouteKey);
        }
    }, [
        getState,
        onRouteFocusParent,
        router,
        setState,
        sourceRouteKey
    ]);
}
